import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {Typography, Box} from "@mui/material";
import { EvidenceWrapper } from "../../components/EvidenceWrapper";
import { evidenceToStandardLicence, getLicenceStandardsEvidences } from "../../api/licence";
import EvidenceList from "../../components/EvidenceList";
import { setLicenceCriteriaEvidences, setLicenceStandardsEvidences } from "../../redux/reducers/licence";
import EvidencesTable from "../../components/EvidencesTable";
import EvidencePopup from "../../components/EvidencePopup";
import SplitButton from "../../components/SplitButton";
import { uploadFile } from "../../api/evidence";

const EvidenceContents = (props: any) => {

    const { standardId } = props;
    const currentClub = useSelector((state: any) => state.clubDetails);
    const standardsEvidences = useSelector((state: any) => state.licence.standardsEvidences);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const fileInputRef:any = useRef(null);
    const [isOpenLibModal, setIsOpenLibModal] = React.useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    useEffect(() => {
        const fetchEvidences = async () => {
            try {
                setIsLoading(true);
                const response = await getLicenceStandardsEvidences({standardId: standardId, clubId: currentClub.id});
                dispatch(setLicenceStandardsEvidences(response));
                setIsLoading(false);
            } catch {

            }
        }
        (standardId !== undefined && standardId) && fetchEvidences();
    }, [standardId])
    
    const handleFileChange = (e:any) => {

        const params:any = {
            clubId: currentClub.id,
            standardId: standardId,
            file: e.target.files[0],
            standardKind: 1,
            currentFolderId: 0
        }

        const fileUpload = async () => {
            const response = await uploadFile(params);
            return response;
        }

        e.target.files[0] && currentClub.id && standardId &&
        fileUpload().then((res) => {
            const tempArr:any = [...standardsEvidences, res];
            dispatch(setLicenceStandardsEvidences(tempArr));
        })                  
    }

    const manageEvidenceClick = (label:any) => {
        switch(label) {
            case 'Add Evidence':
                fileInputRef.current.click();
                break;
            case 'Add Evidence From Library':
                setIsOpenLibModal(true);
                break;
        }
    }

    const linkLibraryFile = (fileData:any) => {
        const linkToStandard = async () => {
            const response = await evidenceToStandardLicence({fileId: fileData.id, standardId: standardId});
            return response;
        }
        linkToStandard().then((res) => {
            const tempArr:any = [...standardsEvidences, res];
            dispatch(setLicenceStandardsEvidences(tempArr));
            setIsOpenLibModal(false);
        })
    }
    return(
        <>
            <Box mb={2}>
                <EvidencePopup isOpen={isOpenLibModal} 
                manageFileSelect={(d:any) => {linkLibraryFile(d)}}
                manageClickAway={() => {setIsOpenLibModal(false)}}/>
                {
                    !isAdmin &&
                    <>
                        <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        />
                        <Box sx={{ float: 'right' }}>
                            <SplitButton
                            options={['Add Evidence', 'Add Evidence From Library']}
                            handleClick={(e:any) => {manageEvidenceClick(e)}}/>
                        </Box>
                    </>
                }
            </Box>
            <EvidencesTable data={standardsEvidences} isLoading={isLoading} bg={'#FAFAFA'}/>
        </>
    )
}

export default EvidenceContents;